import { Store } from "../../../flux/Store";
import { names } from "./ErrorActions";

export interface ErrorStoreState
{
    errorMessage: string;
    isError: boolean;
}

// This Flux store is used to show errors in our app
export class ErrorStore extends Store<ErrorStoreState>
{
    constructor()
    {
        super();
        this.state = { errorMessage: null, isError: false };

        this.register<Error>(names.SET_ERROR, e => {
            if(e.meta === this.dispatchToken) {
                const { message } = e.payload;
                return this.field({ errorMessage: message, isError: true });
            }
        });

        this.register(names.CLEAR_ERROR, e => {
            if(e.meta === this.dispatchToken) {
                return this.field({ errorMessage: null, isError: false });
            }
        })
    }

    isError = () => this.state.isError;
    errorMessage = () => this.state.errorMessage;
}


// WEBPACK FOOTER //
// ./src/app/flux/Error/ErrorStore.ts